import moment from 'moment';
import { getRealXAxisValue } from '@op/utils/chart';
import type { ParamsTimeType } from '@op/types/common';

/**
 * 情报侧图表 x 轴对齐：留存/RPD 等月粒度页面 x 轴为 YYYY-MM，
 * 舆情 getRealXAxisValue(monthly) 会转成 YYYY-MM-DD，导致气泡被判定不在轴上。
 */
export function resolveOpinionChartXAxisValue(
  time: string,
  dateType: ParamsTimeType,
  format: string,
  xAxisData: string[],
): { isInAxis: boolean; realValue: string } {
  if (!xAxisData?.length) {
    return { isInAxis: false, realValue: time };
  }

  if (dateType === 'monthly') {
    if (xAxisData.includes(time)) {
      return { isInAxis: true, realValue: time };
    }

    const monthKey = moment(time).isValid()
      ? moment(time).format('YYYY-MM')
      : time;

    if (xAxisData.includes(monthKey)) {
      return { isInAxis: true, realValue: monthKey };
    }

    return { isInAxis: false, realValue: time };
  }

  const realXAxisValue = getRealXAxisValue({
    xAxis: time,
    dateType,
    format,
    xAxisData,
  });

  return {
    isInAxis: xAxisData.includes(realXAxisValue),
    realValue: realXAxisValue,
  };
}
